import React, { useEffect, useState } from "react";
import { Form, Input, Button, Radio, Typography, Spin, Card, Tabs } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import useRequest from "../hooks/useRequest";
import { ShowToast, Severty } from "../helper/toast";

import DescriptionEditor from "../components/DescriptionEditor";
import { useLocation } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";
import lang from "../helper/lang";
import { noLeadingSpace, noStartSpace } from "../helper/functions";
const { Title } = Typography;

const EmailFormPage = () => {
  const [form] = Form.useForm();
  const { request } = useRequest();
  const { id } = useParams(); // from /content/edit/:id
  const navigate = useNavigate();
  const location = useLocation();
  const [data, setData] = useState(null);
  const [body, setBody] = useState("");
  const [subject, setSubject] = useState("");
  const [description, setDescription] = useState("");
  const [ar_title, setArTitle] = useState("");
  const [ar_subject, setArSubject] = useState("");
  const [ar_description, setArDescription] = useState("");
  const [ar_body, setArBody] = useState("");
  const [fr_title, setFrTitle] = useState("");
  const [fr_subject, setFrSubject] = useState("");
  const [fr_description, setFrDescription] = useState("");
  const [fr_body, setFrBody] = useState("");
  const [nl_title, setNlTitle] = useState("");
  const [nl_subject, setNlSubject] = useState("");
  const [nl_description, setNlDescription] = useState("");
  const [nl_body, setNlBody] = useState("");
  const [th_title, setThTitle] = useState("");
  const [th_subject, setThSubject] = useState("");
  const [th_description, setThDescription] = useState("");
  const [th_body, setThBody] = useState("");
  // Portuguese (Brazil)
  const [pt_br_title, setPtBrTitle] = useState("");
  const [pt_br_subject, setPtBrSubject] = useState("");
  const [pt_br_description, setPtBrDescription] = useState("");
  const [pt_br_body, setPtBrBody] = useState("");
  // Portuguese (Portugal)
  const [pt_pt_title, setPtPtTitle] = useState("");
  const [pt_pt_subject, setPtPtSubject] = useState("");
  const [pt_pt_description, setPtPtDescription] = useState("");
  const [pt_pt_body, setPtPtBody] = useState("");
  const [pl_title, setPlTitle] = useState("");
  const [pl_subject, setPlSubject] = useState("");
  const [pl_description, setPlDescription] = useState("");
  const [pl_body, setPlBody] = useState("");
  const [vi_title, setViTitle] = useState("");
  const [vi_subject, setViSubject] = useState("");
  const [vi_description, setViDescription] = useState("");
  const [vi_body, setViBody] = useState("");
  const [ru_title, setRuTitle] = useState("");
  const [ru_subject, setRuSubject] = useState("");
  const [ru_description, setRuDescription] = useState("");
  const [ru_body, setRuBody] = useState("");
  const [ko_title, setKoTitle] = useState("");
  const [ko_subject, setKoSubject] = useState("");
  const [ko_description, setKoDescription] = useState("");
  const [ko_body, setKoBody] = useState("");
  const [es_title, setEsTitle] = useState("");
  const [es_subject, setEsSubject] = useState("");
  const [es_description, setEsDescription] = useState("");
  const [es_body, setEsBody] = useState("");
  // Traditional Chinese (Taiwan)
  const [zh_tw_title, setZhTwTitle] = useState("");
  const [zh_tw_subject, setZhTwSubject] = useState("");
  const [zh_tw_description, setZhTwDescription] = useState("");
  const [zh_tw_body, setZhTwBody] = useState("");
  // Traditional Chinese (Hong Kong)
  const [zh_hk_title, setZhHkTitle] = useState("");
  const [zh_hk_subject, setZhHkSubject] = useState("");
  const [zh_hk_description, setZhHkDescription] = useState("");
  const [zh_hk_body, setZhHkBody] = useState("");
  // Simplified Chinese
  const [zh_cn_title, setZhCnTitle] = useState("");
  const [zh_cn_subject, setZhCnSubject] = useState("");
  const [zh_cn_description, setZhCnDescription] = useState("");
  const [zh_cn_body, setZhCnBody] = useState("");
  const [status, setStatus] = useState("draft");
  const [loading, setLoading] = useState(false);


  const handleBack = () => {
    navigate(-1);
  };
  const passedRecord = location.state?.record;
  // fetch content if editing
  useEffect(() => {
    if (passedRecord) {
      // Use passed record directly (no need to fetch)
      setData(passedRecord);
      form.setFieldsValue({
        name: passedRecord.name,
        title: passedRecord.title,
        subject: passedRecord.subject,
        description: passedRecord.description,
        body: passedRecord.body,
      });
      setBody(passedRecord.body || passedRecord.description || "");
      setSubject(passedRecord.subject || "");
      setArTitle(passedRecord.ar_title || "");
      setArSubject(passedRecord.ar_subject || "");
      setArDescription(passedRecord.ar_description || "");
      setArBody(passedRecord.ar_body ||  "");
      setFrTitle(passedRecord.fr_title || "");
      setFrSubject(passedRecord.fr_subject || "");
      setFrDescription(passedRecord.fr_description || "");
      setFrBody(passedRecord.fr_body ||  "");
      setNlTitle(passedRecord.nl_title || "");
      setNlSubject(passedRecord.nl_subject || "");
      setNlDescription(passedRecord.nl_description || "");
      setNlBody(passedRecord.nl_body ||  "");
      setThTitle(passedRecord.th_title || "");
      setThSubject(passedRecord.th_subject || "");
      setThDescription(passedRecord.th_description || "");
      setThBody(passedRecord.th_body ||  "");
      // Portuguese (Brazil)
      setPtBrTitle(passedRecord.pt_br_title || "");
      setPtBrSubject(passedRecord.pt_br_subject || "");
      setPtBrDescription(passedRecord.pt_br_description || "");
      setPtBrBody(passedRecord.pt_br_body ||  "");
      // Portuguese (Portugal)
      setPtPtTitle(passedRecord.pt_pt_title || "");
      setPtPtSubject(passedRecord.pt_pt_subject || "");
      setPtPtDescription(passedRecord.pt_pt_description || "");
      setPtPtBody(passedRecord.pt_pt_body ||  "");
      setPlTitle(passedRecord.pl_title || "");
      setPlSubject(passedRecord.pl_subject || "");
      setPlDescription(passedRecord.pl_description || "");
      setPlBody(passedRecord.pl_body ||  "");
      setViTitle(passedRecord.vi_title || "");
      setViSubject(passedRecord.vi_subject || "");
      setViDescription(passedRecord.vi_description || "");
      setViBody(passedRecord.vi_body ||  "");
      setRuTitle(passedRecord.ru_title || "");
      setRuSubject(passedRecord.ru_subject || "");
      setRuDescription(passedRecord.ru_description || "");
      setRuBody(passedRecord.ru_body ||  "");
      setKoTitle(passedRecord.ko_title || "");
      setKoSubject(passedRecord.ko_subject || "");
      setKoDescription(passedRecord.ko_description || "");
      setKoBody(passedRecord.ko_body || "");
      setEsTitle(passedRecord.es_title || "");
      setEsSubject(passedRecord.es_subject || "");
      setEsDescription(passedRecord.es_description || "");
      setEsBody(passedRecord.es_body || "");
      // Traditional Chinese (Taiwan)
      setZhTwTitle(passedRecord.zh_tw_title || "");
      setZhTwSubject(passedRecord.zh_tw_subject || "");
      setZhTwDescription(passedRecord.zh_tw_description || "");
      setZhTwBody(passedRecord.zh_tw_body || "");
      // Traditional Chinese (Hong Kong)
      setZhHkTitle(passedRecord.zh_hk_title || "");
      setZhHkSubject(passedRecord.zh_hk_subject || "");
      setZhHkDescription(passedRecord.zh_hk_description || "");
      setZhHkBody(passedRecord.zh_hk_body || "");
      // Simplified Chinese
      setZhCnTitle(passedRecord.zh_cn_title || "");
      setZhCnSubject(passedRecord.zh_cn_subject || "");
      setZhCnDescription(passedRecord.zh_cn_description || "");
      setZhCnBody(passedRecord.zh_cn_body || "");
      setStatus(passedRecord.status || "draft");
    } else if (id) {
      // No passed data, fetch from backend
      setLoading(true);
      request({
        url: `/admin/email/${id}`,
        method: "GET",
        onSuccess: (res) => {
          setData(res);
          form.setFieldsValue({
            name: res.name,
            title: res.title,
            subject: res.subject,
            body: res.body || res.description,
          });
          setBody(res.body || res.description || "");
          setSubject(res.subject || "");
          setDescription(res.description || "");
          setArTitle(res.ar_title || "");
          setArSubject(res.ar_subject || "");
          setArBody(res.ar_body || res.ar_description || "");
          setFrTitle(res.fr_title || "");
          setFrSubject(res.fr_subject || "");
          setFrBody(res.fr_body || res.fr_description || "");
          setNlTitle(res.nl_title || "");
          setNlSubject(res.nl_subject || "");
          setNlBody(res.nl_body || res.nl_description || "");
          setThTitle(res.th_title || "");
          setThSubject(res.th_subject || "");
          setThBody(res.th_body || res.th_description || "");
          // Portuguese (Brazil)
          setPtBrTitle(res.pt_br_title || "");
          setPtBrSubject(res.pt_br_subject || "");
          setPtBrBody(res.pt_br_body || res.pt_br_description || "");
          // Portuguese (Portugal)
          setPtPtTitle(res.pt_pt_title || "");
          setPtPtSubject(res.pt_pt_subject || "");
          setPtPtBody(res.pt_pt_body || res.pt_pt_description || "");
          setPlTitle(res.pl_title || "");
          setPlSubject(res.pl_subject || "");
          setPlBody(res.pl_body || res.pl_description || "");
          setViTitle(res.vi_title || "");
          setViSubject(res.vi_subject || "");
          setViBody(res.vi_body || res.vi_description || "");
          setRuTitle(res.ru_title || "");
          setRuSubject(res.ru_subject || "");
          setRuBody(res.ru_body || res.ru_description || "");
          setKoTitle(res.ko_title || "");
          setKoSubject(res.ko_subject || "");
          setKoBody(res.ko_body || res.ko_description || "");
          setEsTitle(res.es_title || "");
          setEsSubject(res.es_subject || "");
          setEsDescription(res.es_description || "");
          setEsBody(res.es_body || "");
          // Traditional Chinese (Taiwan)
          setZhTwTitle(res.zh_tw_title || "");
          setZhTwSubject(res.zh_tw_subject || "");
          setZhTwBody(res.zh_tw_body || res.zh_tw_description || "");
          // Traditional Chinese (Hong Kong)
          setZhHkTitle(res.zh_hk_title || "");
          setZhHkSubject(res.zh_hk_subject || "");
          setZhHkBody(res.zh_hk_body || res.zh_hk_description || "");
          // Simplified Chinese
          setZhCnTitle(res.zh_cn_title || "");
          setZhCnSubject(res.zh_cn_subject || "");
          setZhCnBody(res.zh_cn_body || res.zh_cn_description || "");
          setStatus(res.status || "draft");

        },
        onError: (err) => {
          ShowToast(
            err?.response?.data?.message || "Failed to fetch content",
            Severty.ERROR
          );
        },
        onFinally: () => setLoading(false),
      });
    } else {
      // New content case
      form.resetFields();
      setBody("");
      setSubject("");
      setArTitle("");
      setArSubject("");
      setArBody("");
      setFrTitle("");
      setFrSubject("");
      setFrBody("");
      setNlTitle("");
      setNlSubject("");
      setNlBody("");
      setThTitle("");
      setThSubject("");
      setThBody("");
      // Portuguese (Brazil)
      setPtBrTitle("");
      setPtBrSubject("");
      setPtBrBody("");
      // Portuguese (Portugal)
      setPtPtTitle("");
      setPtPtSubject("");
      setPtPtBody("");
      setPlTitle("");
      setPlSubject("");
      setPlBody("");
      setViTitle("");
      setViSubject("");
      setViBody("");
      setRuTitle("");
      setRuSubject("");
      setRuBody("");
      setKoTitle("");
      setKoSubject("");
      setKoBody("");
      setEsTitle("");
      setEsSubject("");
      setEsBody("");
      setEsDescription("");
      // Traditional Chinese (Taiwan)
      setZhTwTitle("");
      setZhTwSubject("");
      setZhTwBody("");
      // Traditional Chinese (Hong Kong)
      setZhHkTitle("");
      setZhHkSubject("");
      setZhHkBody("");
      // Simplified Chinese
      setZhCnTitle("");
      setZhCnSubject("");
      setZhCnBody("");
      setStatus("draft");
    }
  }, [id, passedRecord]);

  const onFinish = (values) => {
    const payload = {
      name: values.name,
      title: values.title,
      subject: values.subject,
      description:values.description,
      body,
      ar_title,
      ar_subject,
      ar_description,
      ar_body,
      fr_title,
      fr_subject,
      fr_description,
      fr_body,
      nl_title,
      nl_subject,
      nl_description,
      nl_body,
      th_title,
      th_subject,
      th_body,
      // Portuguese (Brazil)
      pt_br_title,
      pt_br_subject,
      pt_br_description,
      pt_br_body,
      // Portuguese (Portugal)
      pt_pt_title,
      pt_pt_subject,
      pt_pt_description,
      pt_pt_body,
      pl_title,
      pl_subject,
      pl_description,
      pl_body,
      vi_title,
      vi_subject,
      vi_description,
      vi_body,
      ru_title,
      ru_subject,
      ru_description,
      ru_body,
      ko_title,
      ko_subject,
      ko_description,
      ko_body,
      es_title,
      es_subject,
      es_description,
      es_body,
      // Traditional Chinese (Taiwan)
      zh_tw_title,
      zh_tw_subject,
      zh_tw_description,
      zh_tw_body,
      // Traditional Chinese (Hong Kong)
      zh_hk_title,
      zh_hk_subject,
      zh_hk_description,
      zh_hk_body,
      // Simplified Chinese
      zh_cn_title,
      zh_cn_subject,
      zh_cn_description,
      zh_cn_body,
      status,
    };

    request({
      url: id ? `/admin/email/edit/${id}` : `/admin/email/add`,
      method: id ? "PUT" : "POST",
      data: payload,
      onSuccess: () => {
        ShowToast("Content saved successfully", Severty.SUCCESS);
        navigate("/email-template");
      },
      onError: (err) => {
        ShowToast(
          err?.response?.data?.message || "Failed to save content",
          Severty.ERROR
        );
      },
    });
  };

  return (
    <>
      <div className="back-box-btn">
        <Button onClick={handleBack} className="back-button mb-2">
          <ArrowLeftOutlined /> {lang("Back")}
        </Button>
      </div>
      <Card title={id ? "Edit Email Template" : "Add New Email Template"}>
        {loading ? (
          <Spin />
        ) : (
          <Form
            layout="vertical"
            form={form}
            id="add-content-form"
            onFinish={onFinish}
          >
            <Form.Item
              label="Template Name"
              name="name"
              rules={[
                { required: true, message: "Template Name is required" },
                { validator: noLeadingSpace },
              ]}
            >
              <Input placeholder="e.g. Welcome Email Template" />
            </Form.Item>

            <Tabs defaultActiveKey="english">
              {[
                {
                  key: "english",
                  label: "English",
                  titleState: null,
                  subjectState: null,
                  descriptionState: null,
                  bodyState: body,
                  setBody,
                  titleSetter: null,
                  subjectSetter: null,
                  descriptionSetter: null,
                  required: true,
                },
                {
                  key: "arabic",
                  label: "Arabic",
                  titleState: ar_title,
                  subjectState: ar_subject,
                  bodyState: ar_body,
                  descriptionState: ar_description,
                  setBody: setArBody,
                  titleSetter: setArTitle,
                  subjectSetter: setArSubject,
                  descriptionSetter: setArDescription,
                },
                {
                  key: "french",
                  label: "French",
                  titleState: fr_title,
                  subjectState: fr_subject,
                  bodyState: fr_body,
                  descriptionState: fr_description,
                  setBody: setFrBody,
                  titleSetter: setFrTitle,
                  subjectSetter: setFrSubject,
                  descriptionSetter: setFrDescription,
                },
                {
                  key: "dutch",
                  label: "Dutch",
                  titleState: nl_title,
                  subjectState: nl_subject,
                  bodyState: nl_body,
                  descriptionState: nl_description,
                  setBody: setNlBody,
                  titleSetter: setNlTitle,
                  subjectSetter: setNlSubject,
                  descriptionSetter: setNlDescription,
                },
                {
                  key: "thai",
                  label: "Thai",
                  titleState: th_title,
                  subjectState: th_subject,
                  bodyState: th_body,
                  descriptionState: th_description,
                  setBody: setThBody,
                  titleSetter: setThTitle,
                  subjectSetter: setThSubject,
                  descriptionSetter: setThDescription,
                },
                {
                  key: "portuguese_brazil",
                  label: "Portuguese (Brazil)",
                  titleState: pt_br_title,
                  subjectState: pt_br_subject,
                  bodyState: pt_br_body,
                  descriptionState: pt_br_description,
                  setBody: setPtBrBody,
                  titleSetter: setPtBrTitle,
                  subjectSetter: setPtBrSubject,
                  descriptionSetter: setPtBrDescription,
                },
                {
                  key: "portuguese_portugal",
                  label: "Portuguese (Portugal)",
                  titleState: pt_pt_title,
                  subjectState: pt_pt_subject,
                  bodyState: pt_pt_body,
                  descriptionState: pt_pt_description,
                  setBody: setPtPtBody,
                  titleSetter: setPtPtTitle,
                  subjectSetter: setPtPtSubject,
                  descriptionSetter: setPtPtDescription,
                },
                {
                  key: "polish",
                  label: "Polish",
                  titleState: pl_title,
                  subjectState: pl_subject,
                  bodyState: pl_body,
                  descriptionState: pl_description,
                  setBody: setPlBody,
                  titleSetter: setPlTitle,
                  subjectSetter: setPlSubject,
                  descriptionSetter: setPlDescription,
                },
                {
                  key: "vietnamese",
                  label: "Vietnamese",
                  titleState: vi_title,
                  subjectState: vi_subject,
                  bodyState: vi_body,
                  descriptionState: vi_description,
                  setBody: setViBody,
                  titleSetter: setViTitle,
                  subjectSetter: setViSubject,
                  descriptionSetter: setViDescription,
                },
                {
                  key: "russian",
                  label: "Russian",
                  titleState: ru_title,
                  subjectState: ru_subject,
                  bodyState: ru_body,
                  descriptionState: ru_description,
                  setBody: setRuBody,
                  titleSetter: setRuTitle,
                  subjectSetter: setRuSubject,
                  descriptionSetter: setRuDescription,
                },
                {
                  key: "korean",
                  label: "Korean",
                  titleState: ko_title,
                  subjectState: ko_subject,
                  bodyState: ko_body,
                  descriptionState: ko_description,
                  setBody: setKoBody,
                  titleSetter: setKoTitle,
                  subjectSetter: setKoSubject,
                  descriptionSetter: setKoDescription,
                },
                {
                  key: "spanish",
                  label: "Spanish",
                  titleState: es_title,
                  subjectState: es_subject,
                  bodyState: es_body,
                  descriptionState: es_description,
                  setBody: setEsBody,
                  titleSetter: setEsTitle,
                  subjectSetter: setEsSubject,
                  descriptionSetter: setEsDescription,
                },
                {
                  key: "traditional_chinese_taiwan",
                  label: "Traditional Chinese (Taiwan)",
                  titleState: zh_tw_title,
                  subjectState: zh_tw_subject,
                  bodyState: zh_tw_body,
                  descriptionState: zh_tw_description,
                  setBody: setZhTwBody,
                  titleSetter: setZhTwTitle,
                  subjectSetter: setZhTwSubject,
                  descriptionSetter: setZhTwDescription,
                },
                {
                  key: "traditional_chinese_hongkong",
                  label: "Traditional Chinese (Hong Kong)",
                  titleState: zh_hk_title,
                  subjectState: zh_hk_subject,
                  bodyState: zh_hk_body,
                  descriptionState: zh_hk_description,
                  setBody: setZhHkBody,
                  titleSetter: setZhHkTitle,
                  subjectSetter: setZhHkSubject,
                  descriptionSetter: setZhHkDescription,
                },
                {
                  key: "simplified_chinese",
                  label: "Simplified Chinese",
                  titleState: zh_cn_title,
                  subjectState: zh_cn_subject,
                  bodyState: zh_cn_body,
                  descriptionState: zh_cn_description,
                  setBody: setZhCnBody,
                  titleSetter: setZhCnTitle,
                  subjectSetter: setZhCnSubject,
                  descriptionSetter: setZhCnDescription,
                },
              ].map((lang) => (
                <Tabs.TabPane tab={lang.label} key={lang.key}>
                  <Form.Item
                    label={`Title (${lang.label})`}
                    name={lang.key === "english" ? "title" : undefined}
                    rules={
                      lang.required
                        ? [
                            { required: true, message: "Title is required" },
                            { validator: noLeadingSpace },
                          ]
                        : undefined
                    }
                  >
                    <Input
                      value={
                        lang.key === "english" ? undefined : lang.titleState
                      }
                      onChange={
                        lang.key === "english"
                          ? undefined
                          : (e) => lang.titleSetter(e.target.value)
                      }
                      placeholder={`e.g. Title in ${lang.label}`}
                    />
                  </Form.Item>

                  <Form.Item
                    label={`Subject (${lang.label})`}
                    name={lang.key === "english" ? "subject" : undefined}
                    rules={
                      lang.required
                        ? [
                            { required: true, message: "Subject is required" },
                            { validator: noLeadingSpace },
                          ]
                        : undefined
                    }
                  >
                    <Input
                      value={
                        lang.key === "english" ? undefined : lang.subjectState
                      }
                      onChange={
                        lang.key === "english"
                          ? undefined
                          : (e) => lang.subjectSetter(e.target.value)
                      }
                      placeholder={`e.g. Subject in ${lang.label}`}
                    />
                  </Form.Item>

                  <Form.Item
                    label={`Description (${lang.label})`}
                    name={lang.key === "english" ? "description" : undefined}
                    rules={
                      lang.required
                        ? [
                            { required: true, message: "Description is required" },
                            { validator: noLeadingSpace },
                          ]
                        : undefined
                    }
                  >
                    <Input
                      value={
                        lang.key === "english" ? undefined : lang.descriptionState
                      }
                      onChange={
                        lang.key === "english"
                          ? undefined
                          : (e) => lang.descriptionSetter(e.target.value)
                      }
                      placeholder={`e.g. Description in ${lang.label}`}
                    />
                  </Form.Item>

                  <Form.Item
                    label={`Body (${lang.label})`}
                    name={lang.key === "english" ? "body" : undefined}
                    rules={
                      lang.required
                        ? [
                            { required: true, message: "Body is required" },
                            { validator: noStartSpace },
                          ]
                        : undefined
                    }
                  >
                    <DescriptionEditor
                      placeholder={`Enter email body in ${lang.label}...`}
                      value={lang.bodyState}
                      onChange={lang.setBody}
                    />
                  </Form.Item>
                </Tabs.TabPane>
              ))}
            </Tabs>

            <Form.Item label="Status">
              <Radio.Group
                value={status}
                onChange={(e) => setStatus(e.target.value)}
                buttonStyle="solid"
              >
                <Radio.Button value="draft">Save as Draft</Radio.Button>
                <Radio.Button value="published">Publish</Radio.Button>
              </Radio.Group>
            </Form.Item>

            <Form.Item>
              <Button htmlType="submit" type="primary" block>
                {id ? "Update Email Template" : "Create Email Template"}
              </Button>
            </Form.Item>
          </Form>
        )}
      </Card>
    </>
  );
};

export default EmailFormPage;